module.exports = __webpack_public_path__ + "static/img/tuichu.12b5fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/tuichu.png
// module id = cErH
// module chunks = 1